export const socialsData = {
    github: 'https://github.com/SubhamGupta007',
    facebook: 'https://www.facebook.com/profile.php?id=100040666418840',
    linkedIn: 'https://www.linkedin.com/in/subham-gupta-2398361a9/',
    instagram: 'https://www.instagram.com/subhamgupta173/?hl=en',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/webdeveshverma',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@webdeveshverma',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}